'use client';

import { R40Values } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface CalculatorInputsProps {
  values: R40Values;
  onValuesChange: (field: keyof R40Values, value: number | string) => void;
  translations: ToolsTranslations['r40'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: CalculatorInputsProps) {
  const handleInputChange = (field: keyof R40Values, value: string) => {
    const cleaned = value.replace(/\s/g, '');
    const numValue = parseFloat(cleaned);
    if (!isNaN(numValue)) {
      onValuesChange(field, numValue);
    }
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <label htmlFor="revenue-growth" className="block text-sm font-medium text-gray-700">{translations.revenueGrowthPercent}</label>
        <div className="relative">
          <input id="revenue-growth" type="text" value={values.revenueGrowthPercent.toString()} onChange={(e) => handleInputChange('revenueGrowthPercent', e.target.value)} className={inputClass} placeholder="0" />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">%</span>
        </div>
      </div>
      <div className="space-y-3">
        <label htmlFor="profit-margin" className="block text-sm font-medium text-gray-700">{translations.profitMarginPercent}</label>
        <div className="relative">
          <input id="profit-margin" type="text" value={values.profitMarginPercent.toString()} onChange={(e) => handleInputChange('profitMarginPercent', e.target.value)} className={inputClass} placeholder="0" />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">%</span>
        </div>
      </div>
    </div>
  );
}


